import { GenericField } from '@axinom/mosaic-ui';
import { type FieldHookConfig, useField } from 'formik';
import React from 'react';
import type { RowDataFieldProps } from '../CustomizableServiceDeploymentCreate.types';
import { RowDataList } from './RowDataList';

type RowSelectFieldProps = FieldHookConfig<RowDataFieldProps> & {
  /** Maximum number of items which can be assigned */
  max?: number;
  /** Label to be displayed */
  label: string;

  type: string;

  disabled: boolean;
};

export const RowSelectField: React.FC<RowSelectFieldProps> = ({
  max,
  label,
  name,
  type,
  disabled,
}) => {
  const [field, , helpers] = useField(name);

  return (
    <>
      <GenericField label={label} name={field?.name}>
        <RowDataList
          maxItems={max}
          value={field?.value ?? []}
          onChange={(value) => helpers.setValue(value)}
          type={type}
          disabled={disabled}
        />
      </GenericField>
    </>
  );
};
